import * as React from 'react';

import { FormattedMessage, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';

import { logout, validatePhone } from 'actions/account';
import { Button } from 'components/Button';
import { Form } from 'components/Form';
import { FieldText, InputText } from 'components/Input';
import { LayoutHeader } from 'components/Layout';
import { APPLICATION_FORM_NAME, ROUTE_WALLET_DASHBOARD } from 'constants/app';
import { normalizePhone } from 'helper/form';
import { injectIntl } from 'helper/redux';
import { validate } from 'helper/validation/account/accountPhoneForm';
import { AccountPhoneForm } from 'models/account';
import { AppState } from 'models/app';

import './AccountPhoneSet.scss';

interface StateProps {
  initialValues: AccountPhoneForm;
  phone: string;
}

interface DispatchProps {
  logout: typeof logout;
  validatePhone: typeof validatePhone;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;
type AccountPhoneSetProps = StateProps & DispatchProps & OwnProps;

@injectIntl()
class AccountPhoneSetContainer extends React.Component<AccountPhoneSetProps, {}> {
  private fieldPhone?: FieldText;

  constructor(props: AccountPhoneSetProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.setFieldPhoneReference = this.setFieldPhoneReference.bind(this);
  }

  componentDidMount() {
    if (this.fieldPhone) {
      (this.fieldPhone.getRenderedComponent() as InputText).focus();
    }
  }

  render() {
    const { initialValues, intl, phone } = this.props;

    if (phone) {
      return <Redirect to={ROUTE_WALLET_DASHBOARD}/>;
    }

    return (
      <Form
        className="o-container o-container--fluid o-container--fluid-vertical"
        form={APPLICATION_FORM_NAME}
        initialValues={initialValues}
        onSubmit={this.onSubmit}
        validate={validate}
      >
        <LayoutHeader actionIcon="ic-arrow-left" actionHandler={this.props.logout}>
          <h1 className="o-layout-header-title"><FormattedMessage id="account.phone.set.title"/></h1>
        </LayoutHeader>

        <p className="account-phone-set__info">
          <FormattedMessage id="account.phone.set.info"/>
        </p>

        <FieldText
          className="o-form-field"
          component={InputText}
          footnote={intl.formatMessage({ id: 'form.footnote.otp.info' })}
          label={intl.formatMessage({ id: 'account.phone.set.phonenumber' })}
          modifier="cancel"
          name="phone"
          normalize={normalizePhone}
          ref={this.setFieldPhoneReference}
          type="tel"
          withRef={true}
        />

        <Button type="submit" className="o-form-button button--full button--primary">
          <FormattedMessage id="account.phone.set.continue"/>
        </Button>
      </Form>
    );
  }

  private onSubmit(formValue: AccountPhoneForm) {
    this.props.validatePhone(formValue);
  }

  private setFieldPhoneReference(field: FieldText) {
    this.fieldPhone = field;
  }
}

export const AccountPhoneSet = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    initialValues: {
      phone: state.accountState.tempAccount.phone
    },
    phone: state.accountState.account.phone
  }), { logout, validatePhone }
)(AccountPhoneSetContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Phone/AccountPhoneSet/AccountPhoneSet.tsx